import { render } from "./DrawerClose.vue?vue&type=template&id=508d7680&scoped=true"
const script = {}

import "./DrawerClose.vue?vue&type=style&index=0&id=508d7680&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508d7680"]])

export default __exports__